import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function fetchABCAnalysis (params) {
    const source = axios.CancelToken.source()
    const url = `${CRM_API_URL}/statistic/menu/abc`
    store.dispatch('requests/addUniqueRequest', { url, source })

    return axios.get(url, { params, cancelToken: source.token }).then(response => response.data)
}

function fetchAggregatorsABCAnalysis (data) {
    const source = axios.CancelToken.source()
    const url = `${CRM_API_URL}/statistic/aggregators/abc`
    store.dispatch('requests/addUniqueRequest', { url, source })

    return axios.post(url, data, { cancelToken: source.token }).then(response => response.data)
}

export default {
    fetchABCAnalysis,
    fetchAggregatorsABCAnalysis,
}
